// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"2e65479d","253":"1e484a08","427":"9311a64d","438":"f8e4b0aa","530":"df649f45","579":"b4b08c43","634":"720303d5","664":"58276cbe","812":"f586ee37"}[chunkId] + ".chunk.js";
};